import { useShadowedDragPreviewRefToSet } from './DragPreviewContext';
import { jsx as _jsx } from "react/jsx-runtime";
const ShadowedDragPreviewContainer = () => {
  const shadowedDragPreviewRef = useShadowedDragPreviewRefToSet();
  return /*#__PURE__*/_jsx("div", {
    ref: shadowedDragPreviewRef
  });
};
export default ShadowedDragPreviewContainer;